export default __webpack_public_path__ + "static/media/Home.19bf34ea.svg";